import { Link } from "react-router-dom";
import { CalendarBlank, MapPin, Users } from "@phosphor-icons/react";
import { formatDateRange } from "../lib/constants";

export function EventCard({ event, index = 0 }) {
  return (
    <Link
      to={`/events/${event.event_id}`}
      data-testid={`event-card-${event.event_id}`}
      className="group block bg-card border border-border rounded-sm overflow-hidden fade-in-up"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms`, transition: "border-color 0.3s cubic-bezier(0.4,0,0.2,1), transform 0.3s cubic-bezier(0.4,0,0.2,1)" }}
      onMouseEnter={(e) => e.currentTarget.style.borderColor = "hsl(3 100% 59% / 0.5)"}
      onMouseLeave={(e) => e.currentTarget.style.borderColor = ""}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-neutral-900">
        {event.cover_image && (
          <img
            src={event.cover_image}
            alt={event.title}
            className="w-full h-full object-cover"
            style={{ transition: "transform 0.6s cubic-bezier(0.4,0,0.2,1)" }}
            onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.06)"}
            onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <div className="px-2 py-1 bg-primary text-primary-foreground text-[10px] font-black uppercase tracking-widest">
            {event.category}
          </div>
          {event.is_featured && (
            <div data-testid={`featured-badge-${event.event_id}`} className="px-2 py-1 bg-white text-black text-[10px] font-black uppercase tracking-widest flex items-center gap-1">
              <span className="w-1.5 h-1.5 bg-primary rounded-full animate-pulse" /> Featured
            </div>
          )}
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center gap-2 text-white/90 text-xs">
            <CalendarBlank size={12} weight="bold" />
            <span className="font-semibold tracking-wide">{formatDateRange(event.date_start, event.date_end)}</span>
          </div>
        </div>
      </div>
      <div className="p-5">
        <h3 className="font-display font-bold text-lg leading-tight mb-2 tracking-tight group-hover:text-primary transition-colors">{event.title}</h3>
        <div className="flex items-center gap-1.5 text-xs text-neutral-400 mb-3">
          <MapPin size={12} weight="fill" className="text-primary" />
          <span>{event.city}, {event.country}</span>
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-white/5">
          <div className="flex flex-wrap gap-1">
            {(event.brands || []).slice(0, 2).map((b) => (
              <span key={b} className="text-[10px] px-1.5 py-0.5 border border-white/10 uppercase tracking-wider text-neutral-300">{b}</span>
            ))}
          </div>
          <div className="flex items-center gap-1 text-xs text-neutral-400">
            <Users size={12} weight="bold" />
            <span>{(event.attendees || []).length}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
